import { Component, Directive, HostBinding, Input } from "@angular/core";
import { Constructor } from "@angular/material/core/common-behaviors/constructor";

export enum Palette {
  interactive0 = "interactive0",
  interactive10 = "interactive10",
  interactive20 = "interactive20",
  interactive50 = "interactive50",
  interactive100 = "interactive100",
  interactive200 = "interactive200",
  interactive300 = "interactive300",

  selected0 = "selected0",
  selected10 = "selected10",
  selected20 = "selected20",
  selected50 = "selected50",
  selected100 = "selected100",
  selected200 = "selected200",
  selected300 = "selected300",

  misc0 = "misc0",
  misc10 = "misc10",
  misc20 = "misc20",
  misc50 = "misc50",
  misc100 = "misc100",
  misc200 = "misc200",
  misc300 = "misc300",

  danger0 = "danger0",
  danger10 = "danger10",
  danger20 = "danger20",
  danger50 = "danger50",
  danger100 = "danger100",
  danger200 = "danger200",
  danger300 = "danger300"
}

export enum PaletteState {
  enabled = "enabled",
  focus = "focus",
  hover = "hover",
  active = "active",
  disabled = "disabled"
}

// todo: figure out return type for mixins
// tslint:disable-next-line:typedef
export function WithPalette<Base extends Constructor<Component>>(
  BaseClass: Base
) {
  @Directive()
  // tslint:disable-next-line:class-name
  class _WithPalette extends BaseClass {
    @Input()
    palette?: Palette;

    @Input()
    paletteState?: PaletteState;

    protected get paletteClassList(): string[] {
      return paletteAndStateToClass(this.palette, this.paletteState);
    }
  }

  return _WithPalette;
}

@Component({
  selector: "exp-palette-container, [exp-palette-container]",
  template: "<ng-content></ng-content>"
})
export class PaletteContainerComponent extends WithPalette(class {}) {
  @HostBinding("class")
  get hostClass(): string {
    return this.paletteClassList
      .filter((className) => className != null)
      .join(" ");
  }
}

function paletteAndStateToClass(
  palette: Palette | undefined | null,
  state: PaletteState | undefined | null
): string[] {
  if (palette == null) {
    return [];
  }

  if (state == null) {
    return [palette];
  }

  return [palette, `${palette}--${state}`];
}
